import { useState } from 'react';
import { Link } from 'react-router-dom';
import { inputClass } from '../components/ui/inputClass';
import { resendConfirmation } from '../api/auth';

export function ResendConfirmationPage() {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault(); setErr(null); setBusy(true);
    try {
      await resendConfirmation(email);
      setSent(true);
    } catch { setErr('Something went wrong. Please try again.'); }
    finally { setBusy(false); }
  }

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950 flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-slate-900 dark:text-slate-50">Resend confirmation</h1>
        </div>
        {sent ? (
          <div className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-6 space-y-3 shadow-sm text-sm text-slate-600 dark:text-slate-300">
            <p>If that email is registered and unconfirmed, a new confirmation link is on its way.</p>
            <p>
              <Link className="font-medium text-teal-600 dark:text-teal-400 hover:underline" to="/login">
                Back to sign in
              </Link>
            </p>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-6 space-y-4 shadow-sm">
            <div>
              <label className="mb-1 block text-sm font-medium text-slate-700 dark:text-slate-300">Email</label>
              <input
                className={inputClass}
                type="email"
                required
                placeholder="you@example.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
            </div>
            {err && <p className="text-sm text-red-500">{err}</p>}
            <button
              className="w-full rounded-lg bg-teal-600 dark:bg-teal-500 py-2.5 text-sm font-semibold text-white hover:bg-teal-700 dark:hover:bg-teal-600 disabled:opacity-50 transition-colors cursor-pointer"
              disabled={busy}
            >
              {busy ? 'Sending…' : 'Send confirmation'}
            </button>
            <p className="text-center text-sm text-slate-500 dark:text-slate-400">
              <Link className="font-medium text-teal-600 dark:text-teal-400 hover:underline" to="/login">
                Back to sign in
              </Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
